<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-app>
    <v-app-bar
            app
      color="primary"
      dark>

      <div class="d-flex align-center">
        <v-img src="./assets/LOGO_POWERFLEET.png" max-height="100" max-width="150" alt=""></v-img>
      </div>
      <v-spacer></v-spacer>
      <div class="d-flex over_mapTopData_prisma">
        <v-img src="./assets/alexandroupolis2.png" max-height="75" max-width="100" alt=""></v-img>
        <v-divider class="mx-2" vertical
        ></v-divider>
      </div>
      <div class="d-flex align-center">
      <v-img src="./assets/alexandroupolis1.png" max-height="50" max-width="70" alt="Alexandroupolis Icon" contain></v-img>
      </div>
    </v-app-bar>

    <v-main>
      <Map/>
    </v-main>

    <ErrorSnackBar v-if="$store.getters.snackBar"/>

    <LoadingModal :isLoading="$store.getters.loadingModal"/>

  </v-app>
</template>

<script>

  import utils from './utilities'
  import Map from "./components/map/Map";
  import ErrorSnackBar from "@/components/ErrorSnackBar";
  import LoadingModal from "@/components/LoadingModal";
  import {i18n} from "@/plugins/i18n";
  import request from "@/requests";
  import service from "@/services";

export default {

  name: 'App',
  components: {Map, ErrorSnackBar, LoadingModal},
  data: () => ({
    i18n,
    error: false,
  }),

  methods: {

    selectPlate() {

      request.get('/vehiclesCurrentPosition', this.getVehiclesPositionCallBack);
      request.get('/vehiclesRoutes', this.getVehiclesRoutesCallBack);

    },

    getVehiclesRoutesCallBack(response) {

      if (response.length > 0) {
        this.$store.commit('setVehiclesRoutes', response[0].routePoints);
        return
      }
      this.$store.commit('setVehiclesRoutes', []);
    },

    getVehiclesPositionCallBack(response) {

      if (response.length > 0) {
        this.$store.commit('setVehiclePosition', response);
      }
      else {
        this.$store.commit('setVehiclePosition', []);
      }
      service.cancelGetVehiclesPosition();
      service.getVehiclesPosition();
    },

  },

  created() {

    window.scrollTo(0, 0);
    if(utils.getLocalStorage("language")){
      i18n.locale = utils.getLocalStorage("language");
    }
    this.selectPlate();
  }
};
</script>

<style scoped>

  .vehicles {
    z-index: 10 !important;
  }

</style>
